import React from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import DatePicker from 'react-date-picker';
import DateTimePicker from 'react-datetime-picker'

import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';

import PropTypes from "prop-types";

import axios from 'axios'
import firebase, { db, storage, sendEmail, sendSMS } from "firebase/fbConfig.js"
import moment from 'moment'
import { v1 as uuidv1 } from 'uuid';

import Geocode from "react-geocode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from '@material-ui/core/styles';
import MaterialButton from '@material-ui/core/Button';
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';


// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';


// @material-ui/lab
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import ShipFullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FormLabel from '@material-ui/core/FormLabel';
import FullScreenMap from "../../views/Maps/ShipFullScreenMap";

import FlightSearchForm from "./FlightSearchFormNew";
import PartyFreightSummary from "./PartyFreightSummary";
import { isEmail, isPhoneNumber, itemErrorDetails, onlyNumbers, onlyLettersAndWhitespace } from "../../store/actions/formActions.jsx";
import UserConfirmModal from 'components/Modal/UserConfirm';
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    button: {
        maxWidth: '200px'
    },
    buttonProgress: {
        color: 'white',
        margin: '0 -16px 0 8px'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LoadButton = props => {
    const { children, isLoading, ...rest } = props;
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <Button
                className={classes.button}
                color='primary'
                disabled={isLoading}
                {...rest}
            >
                {children}
                {isLoading && (
                    <CircularProgress size={20} className={classes.buttonProgress} disableShrink />
                )}
            </Button>
        </div>
    );
}

const filter = createFilterOptions();

class Form extends React.Component {
    state = {
        comment: '',
        queryString: "",
        actionAssigned: false,
        assignedError: false,
        defaultLoaded: false,
        assigningAction: "",
        cardAnimaton: "cardHidden",
        messageSent: false,
        messageError: false,
        mapDataSaved: true
    }
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            shippingMode: '',
            pickUpServices: '',
            dropOffServices: '',
            services: '',
            items: [],
            itemCount: 1,
            userSet: false,
            step5: true,
            item2: false,
            item3: false,
            matchingFlights: [],
            hideFlights: false,
            radius: 200,
            cargoAir: {},
            air: {},
            ground: {},
            ltl: {},
            autoLtl: {},
            openChats: [],

        };

        this.shipmentStatuses = ['Pending', 'Quoted Needs Approval', 'Booked', 'Dispatched', 'In Route to Shipper', 'Arrived at Shipper', 'Driver Departed Shipper', 'Arrived at Airline', 'Tendered to Airline Awaiting Departure', "Aircraft Departed", "Aircraft Arrived", 'Aircraft Download', 'In Route to Consignee', 'Arrived at Consignee', 'Docked', 'Delivered']; this.financialStatuses = ['Unquoted', 'Quoted', 'Quote Authorized', 'Pricing Final', 'Invoiced', 'Past Due', 'Paid'];
        this.deliveryTypes = [{ string: '', value: '' }, { string: 'Next Flight Out', value: 'Air' }, { string: 'Next Day Air', value: 'Scheduled Air' }, { string: 'Dedicated Ground', value: 'Ground' }, { string: 'LTL', value: 'LTL' }, { string: 'Direct LTL', value: 'Additional Options' }];
        this.billingParties = ['Shipper', 'Consignee', 'Third Party'];
        this.militaryTime = ['', '0000', '0030', '0100', '0130', '0200', '0230', '0300', '0330', '0400', '0430', '0500', '0530', '0600', '0630', '0700', '0730', '0800', '0830', '0900', '0930', '1000', '1030', '1100', '1130', '1200', '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030', '2100', '2130', '2200', '2230', '2300', '2330'];

    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        console.log("error1", this.state)
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
    }

    handleQuoteDateTimeChange = (date, obj) => {
        let bucket = this.state[obj] ? this.state[obj] : {};
        bucket['quoteETA'] = date;
        this.setState({
            [obj]: bucket,
        });
    };

    handleQuoteWindowTimeChange = (e, obj, type) => {
        const bucket = this.grabData(obj) ? this.grabData(obj) : {};
        bucket[type] = e.target.value;
        this.setState({
            [obj]: bucket
        });
    }

    handleArrChange = (e, arr) => {
        const array = this.state.orderData[arr];
        array[e.target.id] = e.target.value;
        this.setState({
            [arr]: array
        })
    }

    handleItemChange = (e, i) => {
        const orderData = this.state.orderData;
        orderData.items[i][e.target.id || e.target.name] = e.target.value;
        console.log(orderData, e.target.id, e.target.value);
        this.setState({ orderData: orderData });
    }

    handleItemSelectChange = (e, i) => {
        const orderData = this.state.orderData;
        orderData.items[i][e.target.name] = e.target.value

        this.setState({ orderData: orderData });
    }

    handleDateChange = (date, obj) => {
        if (date) {
            const bucket = this.state.orderData[obj];
            bucket['date'] = date;
            this.setState({
                [obj]: bucket
            })
        }
    }

    handleDateTimeChange = (date, obj) => {
        let bucket = this.state[obj];
        console.log(bucket)
        bucket['quoteETA'] = date;
        this.setState({
            [obj]: bucket
        })
    }

    handleToggleItemServices(value, iterator) {
        var orderData = this.state.orderData;
        value = value.includes(" ") ? value.split(" ").join("") : value;
        orderData.items[iterator][`is${value}`] == true ? delete orderData.items[iterator][`is${value}`] : orderData.items[iterator][`is${value}`] = true;
        this.setState({ orderData: orderData });
    }

    handlePickUpDateChange = (pickUpDate) => {
        //console.log(pickUpDate._d)
        if (pickUpDate) {
            this.setState(() => ({ pickUpDate: pickUpDate, pickUpAPI: moment(pickUpDate).format('YYYY-MM-DD') }))
        }
    }

    handleDropOffDateChange = (dropOffDate) => {
        //console.log(dropOffDate)
        if (dropOffDate) {
            this.setState(() => ({ dropOffDate: dropOffDate }))
        }
    }

    // only make future selectable  
    valid = (current) => {
        return current.isAfter(Datetime.moment().subtract(1, 'day'));
    };

    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            pickUpDriverContactLoaded: false
        })
        // console.log(this.state)
    }

    handleSelectChangeObj = (e, obj) => {
        const bucket = this.state.orderData[obj];
        bucket[e.target.name] = e.target.value;
        this.setState({
            [obj]: bucket
        });
    }

    handleSelectChangeStateObj = (e, obj) => {
        let orderData = this.state.orderData;
        orderData[obj][e.target.name] = e.target.value;
        this.setState({
            orderData: orderData
        });
    }

    handleTogglePickupServices(value) {
        const { pickUpServices } = this.state;
        const currentIndex = pickUpServices.indexOf(value);
        const newPickUpServices = [...pickUpServices];

        if (currentIndex === -1) {
            newPickUpServices.push(value);
        } else {
            newPickUpServices.splice(currentIndex, 1);
        }

        this.setState({
            pickUpServices: newPickUpServices
        });
    }

    handleToggleDropOffServices(value) {
        const { dropOffServices } = this.state;
        const currentIndex = dropOffServices.indexOf(value);
        const newDropOffServices = [...dropOffServices];

        if (currentIndex === -1) {
            newDropOffServices.push(value);
        } else {
            newDropOffServices.splice(currentIndex, 1);
        }

        this.setState({
            dropOffServices: newDropOffServices
        });
    }

    handleToggleServices(value, obj) {
        const orderData = this.state.orderData;
        const { services } = orderData[obj];
        const index = services.indexOf(value);

        if (index !== -1) {
            services.splice(index, 1)
        } else {
            services.push(value)
        }

        orderData[obj].services = services;

        this.setState({ orderData: orderData });
    }

    handleClickOpen = (modal) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    closeSnack = (snack) => {
        this.setState({
            [snack]: false
        })
    }

    grabData = (key) => {

        const checkObj = () => {
            const checkArray = () => {
                if ((Array.isArray(this.state[key]) && this.state[key].length) || !this.state.orderData[key] || (this.state[key] && this.state[key].length && (this.state.orderData[key] && !this.state.orderData[key].length))) {
                    return this.state[key];
                } else {
                    return this.state.orderData[key];
                }
            }

            if (Array.isArray(this.state[key]) || Array.isArray(this.state.orderData[key])) {
                return checkArray();
            }

            if (typeof this.state[key] === 'object' && this.state[key] !== null && Object.keys(this.state[key]).length) {
                return this.state[key]
            } else if (this.state.orderData[key] && typeof this.state.orderData[key] === 'object' && Object.keys(this.state.orderData[key]).length) {
                return this.state.orderData[key]
            } else {
                return null
            }
        }

        const checkOther = () => {
            if (this.state[key]) {
                return this.state[key];
            } else if (this.state.orderData[key]) {
                return this.state.orderData[key];
            } else {
                return null
            }
        }

        if ((typeof this.state[key] === 'object' && this.state[key] !== null) || (typeof this.state.orderData[key] === 'object' && this.state.orderData[key] !== null)) {
            return checkObj();
        } else {
            return checkOther();
        }
    }

    uploadImage = (refString, pic) => {
        console.log("Uploading image");
        return new Promise((resolve, reject) => {
            // create storage ref
            var storageRef = storage.ref(refString);
            // upload pic
            var uploadTask = storageRef.put(pic);
            // update progress bar
            uploadTask.on('state_changed', (snapshot) => {
                // Observe state change events such as progress, pause, and 
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var Progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.setState({ uploadProgress: 'Progress is ' + Progress + '% done' });

                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        this.setState({ uploadProgress: ' Upload is paused' });
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        this.setState({ uploadProgress: 'Upload is running' });
                        break;
                }

            }, (error) => {
                // Handle unsuccessful uploads
                console.log(error)
            }, () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    resolve(downloadURL)
                });
            })
        })
    }

    // groupOrder = () => {
    //     let data = db.collection("haney-orders")
    //     .get().then((snapshot) => {
    //         //console.log(snapshot)
    //         const data = []
    //         // Parse data into array like in firebase.js
    //         snapshot.forEach(async (doc) => {
    //             var docData = doc.data()
    //             var docObj = {
    //                 name: docData.name,
    //                 id: doc.id,
    //             }
    //             data.push(docObj);
    //             console.log(doc.id)
    //             await db.collection('haney-groups').doc("0GaWMBdpfwObZwfLePWJ").collection("orders").doc(doc.id).set({
    //                 id: doc.id
    //             }, { merge: true })
    //         })
    //         return (data)
    //     }, (error) => {
    //         console.log('error fetching data: ', error)
    //     }).then(data => {
    //         data
    //         this.setState({
    //             vendorsData: data,
    //             vendorsDataLoaded: true,
    //         })
    //     })


    // // update firestore document with PENDING and comment
    // db.collection("haney-orders").doc(this.state.orderData.id).set({
    //     status: "canceled",
    //     canceledAt: new Date()
    // }, { merge: true }).then(() => {
    //     db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
    //         status: "canceled",
    //         canceledAt: new Date()
    //     }, { merge: true }).then(async () => {
    //         // console.log(this.state.pickUpDriverContact.email)
    //         //const email = this.props.user.email

    //         // let subject = `Your order has been quoted!`
    //         // let html = `<p>Hello </p>`
    //         // html += `<p>Order #: ${this.state.orderData.id}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
    //         // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
    //         // const emails = [this.state.orderUserData.email]
    //         // const attatchment = true;
    //         // const emailReturn = await sendEmail({
    //         //     emails,
    //         //     subject,
    //         //     html,
    //         //     attatchment
    //         // })

    //     }).then(() => {
    //         // window.location.reload()
    //     })
    // })
    // }


    cancelOrder = () => {
        // update firestore document with PENDING and comment
        db.collection("haney-orders").doc(this.state.orderData.id).set({
            status: "canceled",
            canceledAt: new Date()
        }, { merge: true }).then(() => {
            db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                status: "canceled",
                canceledAt: new Date()
            }, { merge: true }).then(async () => {
                // console.log(this.state.pickUpDriverContact.email)
                //const email = this.props.user.email

                // let subject = `Your order has been quoted!`
                // let html = `<p>Hello </p>`
                // html += `<p>Order #: ${this.state.orderData.id}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
                // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                // const emails = [this.state.orderUserData.email]
                // const attatchment = true;
                // const emailReturn = await sendEmail({
                //     emails,
                //     subject,
                //     html,
                //     attatchment
                // })

            }).then(() => {
                window.location.reload()
            })
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const associations = [
            { key: 'air', label: 'Air' },
            { key: 'cargoAir', label: 'Next Day Air' },
            { key: 'ground', label: 'Ground' },
            { key: 'ltl', label: 'Additional Options' },
            { key: 'autoLtl', label: 'LTL' }
        ];
        const errors = [];

        this.setState({ quoteSending: true })

        if (!this.state.airQuote && !this.state.cargoAirQuote && !this.state.groundQuote && !this.state.ltlQuote && !this.state.autoLtlQuote && !this.state.deliveryType) {
            this.setState({ errorSnackMessage: `Please fill out a quote`, errorSnack: true, quoteSending: false });
            return;
        }


        for (let i = 0; i < associations.length; i++) {
            const quoteObject = this.grabData(associations[i].key);
            const quote = this.grabData(`${associations[i].key}Quote`);
            if (quote && !(quoteObject && quoteObject.quoteETA)) {
                errors.push(`ETA for ${associations[i].label}`)
            }
        }

        if (errors.length) {
            this.setState({ errorSnackMessage: `Please fill out the following: ${errors.join(', ')}`, errorSnack: true, quoteSending: false });
            return;
        }

        const data = {
            airQuote: this.grabData('airQuote'),
            cargoAirQuote: this.grabData('cargoAirQuote'),
            subDeliveryType: this.grabData('subDeliveryType'),
            groundQuote: this.grabData('groundQuote'),
            ltlQuote: this.grabData('ltlQuote'),
            autoLtlQuote: this.grabData('autoLtlQuote')
        }

        // update firestore document with PENDING and comment
        db.collection("haney-orders").doc(this.state.orderData.id).set({
            ...data,
            air: this.state.air.quoteETA ? this.state.air : (this.state.orderData.air ? this.state.orderData.air : null),
            cargoAir: this.state.cargoAir.quoteETA ? this.state.cargoAir : (this.state.orderData.cargoAir ? this.state.orderData.cargoAir : null),
            ground: this.state.ground.quoteETA ? this.state.ground : (this.state.orderData.ground ? this.state.orderData.ground : null),
            ltl: this.state.ltl.quoteETA ? this.state.ltl : (this.state.orderData.ltl ? this.state.orderData.ltl : null),
            autoLtl: this.state.autoLtl.quoteETA ? this.state.autoLtl : (this.state.orderData.autoLtl ? this.state.orderData.autoLtl : null),
            userQuoteUID: this.props.authUser.uid,
            userQuoteEmail: this.props.user.email,
            dispatcherID: this.props.authUser.uid,
            flight: this.state.flight ? this.state.flight : null,
            status: "Quoted",
            quotedAt: new Date()
        }, { merge: true }).then(() => {
            // db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
            //     airQuote: this.state.airQuote ? this.state.airQuote : (this.state.orderData.airQuote ? this.state.orderData.airQuote : null),
            //     cargoAirQuote: this.state.cargoAirQuote ? this.state.cargoAirQuote : (this.state.orderData.cargoAirQuote ? this.state.orderData.cargoAirQuote : null),
            //     subDeliveryType: this.state.subDeliveryType ? this.state.subDeliveryType : (this.state.orderData.subDeliveryType ? this.state.orderData.subDeliveryType : null),
            //     groundQuote: this.state.groundQuote ? this.state.groundQuote : (this.state.orderData.groundQuote ? this.state.orderData.groundQuote : null),
            //     ltlQuote: this.state.ltlQuote ? this.state.ltlQuote : (this.state.orderData.ltlQuote ? this.state.orderData.ltlQuote : null),
            //     autoLtlQuote: this.state.autoLtlQuote ? this.state.autoLtlQuote : (this.state.orderData.autoLtlQuote ? this.state.orderData.autoLtlQuote : null),
            //     air: this.state.air ? this.state.air : (this.state.orderData.air ? this.state.orderData.air : null),
            //     cargoAir: this.state.cargoAir ? this.state.cargoAir : (this.state.orderData.cargoAir ? this.state.orderData.cargoAir : null),
            //     ground: this.state.ground ? this.state.ground : (this.state.orderData.ground ? this.state.orderData.ground : null),
            //     ltl: this.state.ltl ? this.state.ltl : (this.state.orderData.ltl ? this.state.orderData.ltl : null),
            //     autoLtl: this.state.autoLtl ? this.state.autoLtl : (this.state.orderData.autoLtl ? this.state.orderData.autoLtl : null),
            //     userQuoteUID: this.props.authUser.uid,
            //     userQuoteEmail: this.props.user.email,
            //     dispatcherID: this.props.authUser.uid,
            //     flight: this.state.flight ? this.state.flight : null,
            //     status: "quoted",
            //     quotedAt: new Date()
            // }, { merge: true })

            db.collection("haney-orders").doc(this.state.orderData.id).collection("statusLogs").add({
                status: "Quoted",
                type: "status",
                updatedAt: new Date(),
                updatedBy: {
                    name: this.props.user.firstName + " " + this.props.user.lastName,
                    uid: this.props.authUser.uid
                },
            }).then(res => console.log("Update succesful"))
                .catch(err => console.log("Error in updating the db"))
                // .then(async () => {
                //     // console.log(this.state.pickUpDriverContact.email)
                //     //const email = this.props.user.email

                //     let subject = `Your order has been quoted!`
                //     let html = `<p>Hello </p>`
                //     html += `<p>Order #: ${this.state.orderData.freightBillNumber}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
                //     // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                //     let billingParty = this.state.orderData.billingParty
                //     let userEmail = ""
                //     if (billingParty == "Shipper") {
                //         userEmail = (this.state.orderData.origin.email ? this.state.orderData.origin.email : this.state.orderUserData.email)
                //     } else if (billingParty == "Consignee") {
                //         userEmail = (this.state.orderData.destination.email ? this.state.orderData.destination.email : this.state.orderUserData.email)
                //     } else if (billingParty == "Third Party") {
                //         userEmail = (this.state.orderData.thirdParty.email ? this.state.orderData.thirdParty.email : this.state.orderUserData.email)
                //     } else {
                //         userEmail = this.state.orderUserData.email
                //     }

                //     const emails = [userEmail]
                //     const attatchment = true;
                //     const emailReturn = await sendEmail({
                //         emails,
                //         subject,
                //         html,
                //         attatchment
                //     })

                // })
                .then(() => {
                    console.log(this.state.orderData)
                    db.collection("notifications").add({
                        description: `#${this.state.orderData.freightBillNumber} has been quoted.`,
                        customerID: this.props.authUser.uid,
                        orderID: this.state.orderData.id,
                        freightBillNumber: this.state.orderData.freightBillNumber,
                        notificationType: "orderQuoted",
                        timestamp: new Date()
                    }).then(async () => {

                        // let subject = `Your order has been quoted!`
                        // let html = `<p>Hello </p>`
                        // html += `<p>Orders #: ${this.state.orderData.id}</p><a href="https://haney-freightways-customer.web.app/orders/">Go to Orders</a>`
                        // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                        // const emails = [this.state.orderUserData.email]
                        // const attatchment = true;
                        // const emailReturn = await sendEmail({
                        //     emails,
                        //     subject,
                        //     html,
                        //     attatchment
                        // })

                    }).then(() => {
                        window.location.reload()
                    })
                })
        })
    }

    saveAsQuote = () => {
        // update firestore document with PENDING and comment
        console.log("saving quote")
        db.collection("TEST-quotes").add({
            uid: this.state.uid ? this.state.uid : null,
            role: this.state.role ? this.state.role : null,
            status: "pending",
            originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
            originContactName: this.state.originContactName ? this.state.originContactName : null,
            originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
            originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
            originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
            originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
            originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
            originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
            originAddress: this.state.originAddress ? this.state.originAddress : null,
            originCity: this.state.originCity ? this.state.originCity : null,
            originState: this.state.originState ? this.state.originState : null,
            originZip: this.state.originZip ? this.state.originZip : null,
            originType: this.state.originType ? this.state.originType : null,
            pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
            pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
            destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
            destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
            destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
            destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
            destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
            destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
            destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
            destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
            destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
            destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
            destinationState: this.state.destinationState ? this.state.destinationState : null,
            destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
            destinationType: this.state.destinationType ? this.state.destinationType : null,
            dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
            dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
            services: this.state.services ? this.state.services : null,
            unNumber: this.state.unNumber ? this.state.unNumber : null,
            properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
            packaging: this.state.packaging ? this.state.packaging : null,
            quantity: this.state.quantity ? this.state.quantity : null,
            weight: this.state.weight ? this.state.weight : null,
            height: this.state.height ? this.state.height : null,
            width: this.state.width ? this.state.width : null,
            depth: this.state.depth ? this.state.depth : null,
            class: this.state.class ? this.state.class : null,
            deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
            flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
            page: window.location.pathname,
            updatedAt: new Date()
        }).then((docRef) => {
            db.collection("TEST-users").doc(this.state.uid).collection("quotes").doc(docRef.id).set({
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "pending",
                originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
                originContactName: this.state.originContactName ? this.state.originContactName : null,
                originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
                originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
                originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
                originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
                originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
                originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
                originAddress: this.state.originAddress ? this.state.originAddress : null,
                originCity: this.state.originCity ? this.state.originCity : null,
                originState: this.state.originState ? this.state.originState : null,
                originZip: this.state.originZip ? this.state.originZip : null,
                originType: this.state.originType ? this.state.originType : null,
                pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
                pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
                destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
                destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
                destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
                destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
                destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
                destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
                destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
                destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
                destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
                destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
                destinationState: this.state.destinationState ? this.state.destinationState : null,
                destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
                destinationType: this.state.destinationType ? this.state.destinationType : null,
                dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
                dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
                services: this.state.services ? this.state.services : null,
                unNumber: this.state.unNumber ? this.state.unNumber : null,
                properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
                packaging: this.state.packaging ? this.state.packaging : null,
                quantity: this.state.quantity ? this.state.quantity : null,
                weight: this.state.weight ? this.state.weight : null,
                height: this.state.height ? this.state.height : null,
                width: this.state.width ? this.state.width : null,
                depth: this.state.depth ? this.state.depth : null,
                class: this.state.class ? this.state.class : null,
                deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
                flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
                page: window.location.pathname,
                updatedAt: new Date()
            }, { merge: true }).then(() => {
                this.props.history.push('/quotes')
            }).then(() => {
                window.location.reload()
            }).catch((err) => {
                console.log(`${err}`)
            })
        }).catch((err) => {
            console.log(`${err}`)
        })
    }


    resetRequest = () => {
        window.location.reload();
    }

    setUser = (user) => {
        this.setState({
            uid: user,
            userSet: true
        })
        console.log(this.state)
    }

    handleGeoChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
        //console.log(this.state)
    }




    getFlights = () => {
        const axios = require("axios");

        this.setState({
            matchingFlights: [],
        })

        Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

        let origin = (this.state.originCity + " " + this.state.originState)
        //console.log(origin)
        // this.setState({
        //   mapDataSaved: false
        // })
        let originCoords = Geocode.fromAddress(origin).then(
            response => {
                //console.log(response.results[0].geometry.location);
                this.setState({
                    originCoords: response.results[0].geometry.location,
                })
                let destination = (this.state.destinationCity + " " + this.state.destinationState)
                //console.log(destination)
                let destinationCoords = Geocode.fromAddress(destination).then(
                    response => {
                        // console.log(response.results[0].geometry.location);
                        this.setState({
                            destinationCoords: response.results[0].geometry.location,
                        })
                        //console.log(this.state);

                    }
                ).then(
                    response => {
                        // console.log(this.state)
                        axios({
                            "method": "GET",
                            "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.originCoords.lat}/${this.state.originCoords.lng}/km/${this.state.radius}/16`,
                            "headers": {
                                "content-type": "application/octet-stream",
                                "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                            }, "params": {
                                "withFlightInfoOnly": "false"
                            }
                        })
                            .then((response) => {
                                this.setState({
                                    originAirports: response.data,
                                })
                                axios({
                                    "method": "GET",
                                    "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.destinationCoords.lat}/${this.state.destinationCoords.lng}/km/${this.state.radius}/16`,
                                    "headers": {
                                        "content-type": "application/octet-stream",
                                        "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                        "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                                    }, "params": {
                                        "withFlightInfoOnly": "false"
                                    }
                                })
                                    .then((response) => {
                                        this.setState({
                                            destinationAirports: response.data,
                                        })
                                        //console.log(this.state.originAirports.items[0].icao)

                                        this.state.originAirports.items.forEach((originAirport) => {
                                            // console.log(originAirport.icao)
                                            let originAirportID = originAirport.icao
                                            axios({
                                                "method": "GET",
                                                "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T00:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T11:59`,
                                                "headers": {
                                                    "content-type": "application/octet-stream",
                                                    "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                                    "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                                                }, "params": {
                                                    "withLeg": "false",
                                                    "direction": "Departure"
                                                }
                                            })
                                                .then((response) => {
                                                    this.setState({
                                                        departingFlights: response.data,
                                                    })
                                                    // console.log(response.data.departures)
                                                    // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                                                    // console.log(departingFlightsMatch)
                                                    let filteredDepartingFlights = this.state.matchingFlights
                                                    // Parse data into array like in firebase.js
                                                    this.state.destinationAirports.items.forEach((destinationAirport) => {
                                                        let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
                                                        // console.log(destinationAirport)
                                                        // console.log(departingFlights)
                                                        if (departingFlights.length > 0) {
                                                            departingFlights.forEach((flight) => {
                                                                let docData = flight
                                                                let docObj = {
                                                                    ...docData,
                                                                    originAirport: originAirport.icao
                                                                }
                                                                filteredDepartingFlights.push(docObj);
                                                            })
                                                        }
                                                    })
                                                    // console.log(originAirport)
                                                    this.setState({
                                                        matchingFlights: filteredDepartingFlights,
                                                    })
                                                    this.state.originAirports.items.forEach((originAirport) => {
                                                        // console.log(originAirport.icao)
                                                        let originAirportID = originAirport.icao
                                                        axios({
                                                            "method": "GET",
                                                            "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T12:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T23:59`,
                                                            "headers": {
                                                                "content-type": "application/octet-stream",
                                                                "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                                                "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                                                            }, "params": {
                                                                "withLeg": "false",
                                                                "direction": "Departure"
                                                            }
                                                        })
                                                            .then((response) => {
                                                                this.setState({
                                                                    departingFlights: response.data,
                                                                })
                                                                // console.log(response.data.departures)
                                                                // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                                                                // console.log(departingFlightsMatch)
                                                                let filteredDepartingFlights = this.state.matchingFlights
                                                                // Parse data into array like in firebase.js
                                                                this.state.destinationAirports.items.forEach((destinationAirport) => {
                                                                    let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
                                                                    // console.log(destinationAirport)
                                                                    // console.log(departingFlights)
                                                                    if (departingFlights.length > 0) {
                                                                        departingFlights.forEach((flight) => {
                                                                            let docData = flight
                                                                            let docObj = {
                                                                                ...docData,
                                                                                originAirport: originAirport.icao
                                                                            }
                                                                            filteredDepartingFlights.push(docObj);
                                                                        })
                                                                    }
                                                                })
                                                                // console.log(originAirport)
                                                                this.setState({
                                                                    matchingFlights: filteredDepartingFlights,
                                                                })
                                                                // console.log(this.state)
                                                            })
                                                            .catch((error) => {
                                                                console.log(error)
                                                            })
                                                    })
                                                })
                                                .catch((error) => {
                                                    console.log(error)
                                                })
                                        })
                                    })
                                    .catch((error) => {
                                        console.log(error)
                                    })
                                // console.log(response)
                            })
                            .catch((error) => {
                                console.log(error)
                            })

                    }
                )
            }
        )

    }

    declineQuote = () => {
        const quoteDeclinedData = {
            status: "Quote Declined",
            canceledRequestedAt: new Date()
        };

        Promise.all([
            db.collection("haney-orders").doc(this.state.orderData.id).set(quoteDeclinedData, { merge: true }),
            db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set(quoteDeclinedData, { merge: true })
        ])
            .then(responses => {
                console.log(responses);
                window.location.reload();
            });
    }

    approveQuote = () => {
        const { uid, id, origin, destination, thirdParty, freightBillNumber, cargoAirQuote, airQuote, autoLtlQuote, groundQuote, ltlQuote, air, cargoAir, ground, autoLtl, ltl } = this.state.orderData;
        let dollarAmount;
        const business = {};
        switch (this.state.orderData.billingParty) {
            case 'Shipper':
                business.businessName = origin.businessName ? origin.businessName : null;
                business.id = origin.entityID ? origin.entityID : null
                break;

            case 'Consignee':
                business.businessName = destination.businessName ? destination.businessName : null;
                business.id = destination.entityID ? destination.entityID : null
                break;

            case 'Third Party':
                business.businessName = thirdParty.businessName ? thirdParty.businessName : null;
                business.id = thirdParty.entityID ? thirdParty.entityID : null
                break;

            default:
                break;
        }

        switch (this.state.deliveryType) {
            case 'Scheduled Air':
                dollarAmount = parseFloat(cargoAirQuote);
                break;

            case 'Air':
                dollarAmount = parseFloat(airQuote);
                break;

            case 'LTL':
                dollarAmount = parseFloat(autoLtlQuote);
                break;

            case 'Ground':
                dollarAmount = parseFloat(groundQuote);
                break;

            case 'Additional Options':
                dollarAmount = parseFloat(ltlQuote);
                break;
            default:
                return;
                break;
        }

        const deliveryInfo = {
            status: "Booked",
            financialStatus: "Quote_Authorized",
            deliveryType: this.state.deliveryType,
            serviceETA: (this.state.deliveryType === "Air") ? air.quoteETA : ((this.state.deliveryType === "Scheduled Air") ? cargoAir.quoteETA : ((this.state.deliveryType === "Ground") ? ground.quoteETA : ((this.state.deliveryType === "LTL") ? autoLtl.quoteETA : ltl.quoteETA))),
            bookedAt: new Date()
        }

        Promise.all([
            db.collection("haney-orders").doc(id).set(deliveryInfo, { merge: true }),
            db.collection("TEST-users").doc(uid).collection("orders").doc(id).set(deliveryInfo, { merge: true }),
            db.collection("notifications").add({
                description: `#${freightBillNumber} quote has been approved.`,
                customerID: this.props.authUser.uid,
                orderID: id,
                freightBillNumber: freightBillNumber,
                notificationType: "quoteApproved",
                timestamp: new Date()
            }),
            db.collection("haney-orders").doc(id).collection("statusLogs").add({
                status: "Booked",
                type: "status",
                updatedAt: new Date(),
                updatedBy: {
                    name: this.props.user.firstName + " " + this.props.user.lastName,
                    uid: this.props.authUser.uid
                },
            }),
            db.collection('haney-orders').doc(id).collection('register').add({
                description: "Initial revenue",
                dollarAmount: dollarAmount,
                type: "quote approved",
                category: "revenue",
                business: business
            })
        ])
            .then(responses => {
                console.log(responses);
                window.location.reload();
            })
    }

    saveInfo = (arr) => {
        const orderData = this.state.orderData;
        orderData[arr]['firstName'] = orderData[arr]['firstName'] ? onlyLettersAndWhitespace(orderData[arr]['firstName']).trim() : null;
        orderData[arr]['lastName'] = orderData[arr]['lastName'] ? onlyLettersAndWhitespace(orderData[arr]['lastName']).trim() : null;
        orderData[arr]['phone'] = orderData[arr]['phone'] ? onlyNumbers(orderData[arr]['phone']) : null;
        orderData[arr]['email'] = orderData[arr]['email'] ? orderData[arr]['email'].trim() : null;

        this.setState({
            errorMessage: "",
            orderData: orderData
        });

        const reqFields = ["firstName", "lastName", "email", "phone", "businessName", "address", "city", "state", "zip"];
        const arrToBP = {
            origin: 'Shipper',
            destination: 'Consignee',
            thirdParty: 'Third Party'
        };

        if (arrToBP[arr] !== this.state.orderData.billingParty) {
            reqFields.splice(0, 4);
        }

        let errorDetails = itemErrorDetails(orderData[arr], reqFields);

        let errorMessage = "";

        for (var i = 0; i < errorDetails.length; i++) {
            if (i === errorDetails.length - 1) {
                errorMessage = errorDetails.length > 1 ? `${errorMessage} and ${errorDetails[i]} are not filled` : `${errorDetails[i]} is not filled`;
            } else {
                errorMessage = errorMessage + errorDetails[i] + ", ";
            }
        }

        if (!errorMessage) {
            Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

            this.setState({ orderData: orderData })
            let cityState = (this.state.orderData[arr]['city'] + " " + this.state.orderData[arr]['state']);
            this.setState({
                mapDataSaved: false
            })
            let originCoords = Geocode.fromAddress(cityState).then(
                response => {
                    // console.log(response.results[0].geometry.location);

                    let orderData = this.state.orderData;
                    orderData['originCoords'] = response.results[0].geometry.location;

                    this.setState({
                        orderData: orderData,
                        mapDataSaved: true
                    })
                    db.collection("haney-orders").doc(this.state.orderData.id).set({
                        [arr]: this.state.orderData[arr],
                        [`${arr}Lat`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lat : null,
                        [`${arr}Lng`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lng : null,
                        page: window.location.pathname,
                        updatedAt: new Date()
                    }, { merge: true }).then(docRef => {
                        db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                            [arr]: this.state.orderData[arr],
                            [`${arr}Lat`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lat : null,
                            [`${arr}Lng`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lng : null,
                            page: window.location.pathname,
                            updatedAt: new Date()
                        }, { merge: true })
                            .then(() => {
                                console.log("User order has been updated")
                                const modalString = arr === 'origin' ? 'updateOrigin' : (arr === 'destination' ? 'updateDestination' : 'updateThirdParty')
                                this.handleClose(modalString);
                            })
                            .catch(err => console.log("Error updating user order", err))
                    }).catch(err => console.log("Could not update haney-orders", err));
                }
            )
        } else {
            this.setState({
                errorMessage: errorMessage
            })
        }
    }

    saveOrigin = () => {
        if (this.state.pickUpDate) {
            Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

            let origin = (this.state.originCity + " " + this.state.originState)
            console.log(origin)
            this.setState({
                mapDataSaved: false
            })
            let originCoords = Geocode.fromAddress(origin).then(
                response => {
                    console.log(response.results[0].geometry.location);
                    this.setState({
                        originCoords: response.results[0].geometry.location,
                        mapDataSaved: true,
                        step1: false,
                        step2: true

                    })
                }
            )
        }
    }

    saveDestination = () => {

        Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

        let destination = (this.state.destinationCity + " " + this.state.destinationState)
        console.log(destination)
        this.setState({
            mapDataSaved: false
        })
        let destinationCoords = Geocode.fromAddress(destination).then(
            response => {
                console.log(response.results[0].geometry.location);
                this.setState({
                    destinationCoords: response.results[0].geometry.location,
                    mapDataSaved: true,
                    step2: false,
                    step3: true

                })
            }
        )
    }

    renewItems = async (id, items) => {
        return new Promise((resolve, reject) => {
            db.collection("haney-orders").doc(id).set({
                items: items,
            }, { merge: true }).then(() => {
                resolve(true);
            });
        })

    }

    saveFreight = () => {

        console.log("save freight func hit");
        const orderID = this.state.orderData.id;
        const items = this.state.orderData.items;

        const reqFields = ["packaging", "quantity", "weight", "length", "height", "width", "description"];
        const errors = [];

        items.map((item, i) => {
            if (item.isHazmat) {
                reqFields.push("unNumber", "properShippingName")
            }

            reqFields.map(req => item[req] ? null : errors.push({ index: i, error: req }));

            if (item.isHazmat) {
                const start = reqFields.length - 3;
                reqFields.splice(start, reqFields.length - start);
            }
        });

        if (!errors.length) {


            const itemsNoFiles = [];
            const allFiles = [];

            for (let i = 0; i < this.state.orderData.items.length; i++) {
                const { files, ...noFiles } = this.state.orderData.items[i];
                itemsNoFiles.push(noFiles);
                allFiles.push(files);
            }


            db.collection("haney-orders").doc(orderID).set({
                items: itemsNoFiles,
                page: window.location.pathname,
                updatedAt: new Date()
            }, { merge: true }).then(docRef => {
                const newFilesReference = [];
                const uploadPromises = [];
                for (let i = 0; i < allFiles.length; i++) {
                    const item = items[i];

                    const oldFiles = [];
                    const newFiles = [];

                    allFiles[i] && allFiles[i].map(file => {
                        if ('file' in file) {
                            const id = uuidv1();
                            newFiles.push({ ...file, id: id });
                        } else {
                            oldFiles.push(file);
                        }
                    })

                    console.log(newFiles);

                    oldFiles.map((file, index) => {
                        if ('files' in itemsNoFiles[i]) {
                            itemsNoFiles[i].files.push(file);
                        } else {
                            itemsNoFiles[i].files = [file]
                        }
                    })

                    const fileIDs = [];

                    newFiles.map(fileObj => {
                        const { file, id } = fileObj;
                        fileIDs.push({ picID: id, itemID: i });
                        // newFilesReference.push({ picID: id });
                        uploadPromises.push(this.uploadImage(`orders/${orderID}/${i}/${id}`, file));
                    })

                    newFilesReference.push(fileIDs);
                }

                Promise.all(uploadPromises).then(downloadURLs => {
                    let count = 0;

                    for (let i = 0; i < newFilesReference.length; i++) {
                        const itemFiles = newFilesReference[i]
                        for (let j = 0; j < itemFiles.length; j++) {
                            const fileObj = {
                                ...itemFiles[j],
                                picURL: downloadURLs[count]
                            }
                            count++;
                            if ('files' in itemsNoFiles[i]) {
                                itemsNoFiles[i].files.push(fileObj);
                            } else {
                                itemsNoFiles[i].files = [fileObj];
                            }
                        }
                    }

                    if (count !== downloadURLs.length - 1) console.log("File saving did not go as planned");

                    const newDocData = {
                        items: itemsNoFiles,
                        page: window.location.pathname,
                        updatedAt: new Date()
                    }

                    Promise.all([
                        db.collection("haney-orders").doc(orderID).set(newDocData, { merge: true }),
                        db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(orderID).set(newDocData, { merge: true })
                    ])
                        .then(responses => {
                            console.log(responses);
                            this.handleClose('updateFreight');
                        })
                })
            }).catch(err => console.log("Could not update haney-orders", err));

        } else {

            const statements = items.map((item, i) => {
                const itemErrors = errors.filter(err => err.index === i);
                if (itemErrors.length) {
                    return `Please fill out the following for item #${i + 1}: ${itemErrors.map(err => err.error).join(', ')}\n`
                } else {
                    return null;
                }
            }).filter(Boolean);

            console.log(statements);

            this.setState({
                errorSnackMessage: statements.join(''),
                errorSnack: true
            });

        }
    }

    step2Back = () => {
        this.setState({
            step1: true,
            step2: false

        })
    }

    step3Back = () => {
        this.setState({
            step2: true,
            step3: false

        })
    }

    getQuote = () => {
        this.setState({
            step4: false,
            step5: true

        })

    }
    saveAsQuote = () => {
        this.setState({
            quote: true,

        })

    }

    step4Back = () => {
        this.setState({
            step3: true,
            step4: false

        })
    }

    step5Back = () => {
        this.setState({
            step4: true,
            step5: false

        })
    }

    addItem = () => {
        const orderData = this.state.orderData;
        orderData.items.push({ id: this.state.itemCount })
        this.setState({
            orderData: orderData,
            itemCount: this.state.itemCount + 1
        })

    }

    removeItem = () => {
        const orderData = this.state.orderData;
        orderData.items.pop();
        this.setState({
            orderData: orderData,
            itemCount: this.state.itemCount - 1
        })
    }

    addItem2 = () => {
        this.setState({
            item3: false
        })
    }

    viewFreight = () => {
        this.setState({
            viewFreight: true
        })
    }

    assignFlightNumber = (flightNumber, originAirport, destinationAirport) => {
        this.setState({
            flightNumber: flightNumber,
            originAirport: originAirport,
            destinationAirport: destinationAirport
        })
    }

    assignUser = (doc, arr, query) => {
        // console.log(doc);
        const orderData = this.state.orderData;
        orderData[arr]['phone'] = doc.cellPhone ? doc.cellPhone : (doc.directPhone ? doc.directPhone : '');
        orderData[arr]['firstName'] = doc.firstName;
        orderData[arr]['lastName'] = doc.lastName;
        orderData[arr]['email'] = doc.email;

        this.setState({
            orderData: orderData,
            [query]: ''
        })
    };

    assignBusiness = (doc, arr, query) => {
        // console.log(doc);
        const orderData = this.state.orderData;

        orderData[arr]['businessName'] = doc.name;
        orderData[arr]['address'] = doc.physicalAddress;
        orderData[arr]['city'] = doc.physicalCity;
        orderData[arr]['state'] = doc.physicalState;
        orderData[arr]['zip'] = doc.physicalZip;

        this.setState({
            orderData: orderData,
            [query]: ''
        })
    }

    assignPic = (files, itemIndex) => {
        const orderData = this.state.orderData;
        orderData.items[itemIndex].files = files;
        this.setState({ orderData: orderData });
    }

    removePicture = (i, j) => {
        this.setState(prevState => {
            const { orderData } = prevState;
            orderData.items[i].files.splice(j, 1);
            return ({
                orderData: orderData
            });
        });
    }

    deliveryType = (type) => {
        this.setState({
            deliveryType: type
        })
    }

    hideFlights = () => {
        this.setState({
            hideFlights: !this.state.hideFlights
        })
    }

    addLeg = () => {
        this.setState({
            leg1: true
        })
    }

    addLeg2 = () => {
        this.setState({
            leg2: true
        })
    }

    removeLeg2 = () => {
        this.setState({
            leg1: false
        })
    }


    addLeg3 = () => {
        this.setState({
            leg3: true
        })
    }

    saveBillingParty = (name, value) => {
        const { orderData } = this.state;
        orderData[name] = value;

        this.setState({ orderData: orderData });

        db.collection("haney-orders").doc(orderData.id).update({
            [name]: value
        }).then(res => console.log("Update succesful"))
            .catch(err => console.log("Error in updating the db"));
    }



    saveShipmentStatus = (name, value) => {
        const { orderData } = this.state;
        orderData[name] = value;

        this.setState({ orderData: orderData });

        db.collection("haney-orders").doc(orderData.id).update({
            [name]: value,
            [value + "At"]: new Date(),
            [value + "By"]: this.props.authUser.uid,
        }).then(res => {
            db.collection("haney-orders").doc(orderData.id).collection("statusLogs").add({
                status: value,
                type: name,
                updatedAt: new Date(),
                updatedBy: {
                    name: this.props.user.firstName + " " + this.props.user.lastName,
                    uid: this.props.authUser.uid
                },
            }).then(res => console.log("Update succesful"))
                .catch(err => console.log("Error in updating the db"));
        })
            .catch(err => console.log("Error in updating the db"));

    }

    changeShipmentStatus = (e) => {
        const { value, name } = e.target;
        console.log(value, name)
        if (!this.state.orderData) return;

        let arrName;

        switch (name) {
            case 'status':
                arrName = 'shipmentStatuses';
                break;

            case 'financialStatus':
                arrName = 'financialStatuses';
                break;

            default:
                return;
                break;
        }

        console.log(this.state.orderData[name]);

        const prevIndex = this[arrName].findIndex(status => status === this.state.orderData[name]);
        const newIndex = this[arrName].findIndex(status => status === value);

        console.log(prevIndex, newIndex);

        if (newIndex < prevIndex && this[arrName][prevIndex] !== 'Docked') {
            console.log('open modal');
            this.setState({ promptModal: true, temp: { name, value } });
        } else if (newIndex > prevIndex || this[arrName][prevIndex] === 'Docked') {
            this.saveShipmentStatus(name, value);
        }
    }


    loadVendorsData = (id) => {
        let data = db.collection("haney-vendors")
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    vendorsData: data,
                    vendorsDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversPickUpData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                //console.log(data)
                this.setState({
                    driversPickUpData: data,
                    driversPickUpDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversDropOffData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    driversDropOffData: data,
                    driversDropOffDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadOrderUserData = (id) => {
        console.log("loading order user data")
        let data = db.collection("TEST-users").doc(this.state.orderData.uid)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    orderUserData: docObj,
                    orderUserDataLoaded: true
                })
            }).then(docObj => {
                if (this.state.orderData.shipperID) {
                    let data = db.collection("haney-shippers").doc(this.state.orderData.shipperID)
                        .get().then((snapshot) => {
                            var docData = snapshot.data()
                            if (docData) {
                                var docObj = {
                                    ...docData,
                                    id: snapshot.id,
                                }
                                return (docObj)
                            } else {
                                return (null)
                            }
                        }, (error) => {
                            console.log('error fetching data: ', error)
                        }).then(docObj => {
                            this.setState({
                                shipperData: docObj,
                                shipperDataLoaded: true
                            })
                        })
                }

            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }




    loadOrdersData = (id) => {
        console.log("loading order data")
        let data = db.collection("haney-orders").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    orderData: docObj,
                    orderDataLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadShipperData = () => {
        console.log("loading order data")
        if (this.state.orderData.shipperID) {
            let data = db.collection("haney-shippers").doc(this.state.orderData.shipperID)
                .get().then((snapshot) => {
                    var docData = snapshot.data()
                    if (docData) {
                        var docObj = {
                            ...docData,
                            id: snapshot.id,
                        }
                        return (docObj)
                    } else {
                        return (null)
                    }
                }, (error) => {
                    console.log('error fetching data: ', error)
                }).then(docObj => {
                    this.setState({
                        shipperData: docObj,
                        shipperDataLoaded: true
                    })
                })
        }

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadPickUpDriverContact = (id) => {
        console.log("loading order data")
        let data = db.collection("TEST-users").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    pickUpDriverContact: docObj,
                    pickUpDriverContactLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    selectFlight = (flight) => {
        console.log("selecting flight")
        console.log(flight)

        const { airlineName, originAirport, destinationAirport } = flight;
        console.log("airlineName")
        console.log(airlineName, originAirport, destinationAirport);
        if (!airlineName) {
            console.log("No airline name given");
            db.collection('haney-orders').doc(this.props.orderID).set({
                flight: flight
            }, { merge: true });
            return this.setState({ flight: flight });
        }

        const airlineRef = db.collection("haney-vendors").where('name', '==', airlineName);

        Promise.all([
            airlineRef.where('airCodes', 'array-contains', originAirport).get(),
            airlineRef.where('airCodes', 'array-contains', destinationAirport).get()
        ])
            .then(responses => {
                const [originAirlinesSnapshot, destinationAirlinesSnapshot] = responses;
                console.log(responses);
                const loopLen = Math.max(originAirlinesSnapshot.docs.length, destinationAirlinesSnapshot.docs.length);

                const [originAirlineDetails, destinationAirlineDetails] = [[], []];
                for (let i = 0; i < loopLen; i++) {
                    if (originAirlinesSnapshot.docs.length > i) {
                        const oAirline = {
                            ...originAirlinesSnapshot.docs[i].data(),
                            id: originAirlinesSnapshot.docs[i].id
                        }

                        originAirlineDetails.push(oAirline);
                    }
                    if (destinationAirlinesSnapshot.docs.length > i) {
                        const dAirline = {
                            ...destinationAirlinesSnapshot.docs[i].data(),
                            id: destinationAirlinesSnapshot.docs[i].id
                        }

                        destinationAirlineDetails.push(dAirline);
                    }
                }

                const addressedOriginVendor = originAirlineDetails.find(obj => obj.physicalAddress);
                const addressedDestinationVendor = destinationAirlineDetails.find(obj => obj.physicalAddress);

                if (addressedOriginVendor) flight.originAirlineAddress = addressedOriginVendor.physicalAddress;
                if (addressedDestinationVendor) flight.destinationAirlineAddress = addressedDestinationVendor.physicalAddress;

                this.setState({
                    originAirlineDetails: originAirlineDetails,
                    destinationAirlineDetails: this.state.additionalLegs ? ((this.state.additionalLegs[0].originAirport == destinationAirlineDetails[0].airCodes) ? this.state.destinationAirlineDetails : destinationAirlineDetails) : destinationAirlineDetails,
                    airportAddressUpdated: true,
                    flight: flight,
                    flightFlights: []
                })

                db.collection('haney-orders').doc(this.props.orderID).set({
                    originAirlineDetails: originAirlineDetails,
                    destinationAirlineDetails: this.state.additionalLegs ? ((this.state.additionalLegs[0].originAirport == destinationAirlineDetails[0].airCodes) ? this.state.destinationAirlineDetails : destinationAirlineDetails) : destinationAirlineDetails,
                    flight: flight
                }, { merge: true });

            })
    }

    selectAdditionalLegs = (flight) => {
        console.log("selecting flight")
        console.log(flight)

        const { airlineName, originAirport, destinationAirport } = flight;
        console.log("airlineName")
        console.log(airlineName, originAirport, destinationAirport);
        if (!airlineName) {
            console.log("No airline name given");
            db.collection('haney-orders').doc(this.props.orderID).set({
                additionalLegs: [flight]
            }, { merge: true });
            return this.setState({
                additionalLegs: [flight]
            });
        }
        const airlineRef = db.collection("haney-vendors").where('name', '==', airlineName);

        Promise.all([
            airlineRef.where('airCodes', 'array-contains', destinationAirport).get()
        ])
            .then(responses => {
                const [destinationAirlinesSnapshot] = responses;
                console.log(responses);
                const loopLen = Math.max(destinationAirlinesSnapshot.docs.length);

                const [destinationAirlineDetails] = [[], []];
                for (let i = 0; i < loopLen; i++) {

                    if (destinationAirlinesSnapshot.docs.length > i) {
                        const dAirline = {
                            ...destinationAirlinesSnapshot.docs[i].data(),
                            id: destinationAirlinesSnapshot.docs[i].id
                        }

                        destinationAirlineDetails.push(dAirline);
                    }
                }

                const addressedDestinationVendor = destinationAirlineDetails.find(obj => obj.physicalAddress);

                if (addressedDestinationVendor) flight.destinationAirlineAddress = addressedDestinationVendor.physicalAddress;

                this.setState({
                    destinationAirlineDetails: destinationAirlineDetails,
                    airportAddressUpdated: true,
                    additionalLegs: [flight]
                })
                db.collection('haney-orders').doc(this.props.orderID).set({
                    destinationAirlineDetails: destinationAirlineDetails,
                    additionalLegs: [flight]
                }, { merge: true });

            })
    }

    openChat = (c) => {
        const chatsOpen = this.state.openChats;
        const index = chatsOpen.indexOf(c);
        if (index > -1) {
            chatsOpen.splice(index, 1);
        } else {
            chatsOpen.splice(chatsOpen.length, 0, c);
        }
        this.setState({ openChats: chatsOpen })
    }



    render() {
        const { classes, modalClose, orderID, authUser, user } = this.props;
        function StyledRadio(props) {

            return (
                <Radio
                    className={classes.root}
                    disableRipple
                    color="default"
                    checkedIcon={< span className={clsx(classes.icon, classes.checkedIcon)
                    } />}
                    icon={< span className={classes.icon} />}
                    {...props}
                />
            );
        }
        // Inspired by blueprintjs
        function StyledRadio(props) {

            return (
                <Radio
                    className={classes.root}
                    disableRipple
                    color="default"
                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                    icon={<span className={classes.icon} />}
                    {...props}
                />
            );
        }
        radiusOptions
        const shippingModes = ['', 'LTL', 'TL']
        const role = ['', 'Shipper', 'Consignee', 'Third Party']
        const locationTypes = ['', 'Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home']
        const packagingTypes = ['', 'Pallets: Standard (40" x 48")', 'Pallets (48" x 48")', 'Pallets (60" x 48")', 'Pallets (enter dimensions)', 'Boxed', 'Crated', 'Drums or Barrels']
        const freightClass = ['', 'I dont know', '50', '55', '60', '65', '70', '77.5', '85', '92.5', '100', '110', '125', '150', '175', '200', '250', '300', '400', '500']
        const radiusOptions = ['', '50', '100', '150', '200', '250', '300']

        if (authUser && !this.state.userSet) { this.setUser(authUser.uid) }
        //console.log(authUser)
        // reset modal when closed
        if (this.state.messageSent) { this.resetRequest() }

        let pathname = window.location.pathname
        console.log(this.state)


        if (user.dataLoaded
            && !this.state.orderDataLoaded && !this.state.vendorsDataLoaded && orderID) {
            this.loadOrdersData(orderID)
            this.loadVendorsData()
        }

        if (this.state.vendorPickUp && !this.state.driversPickUpDataLoaded) {
            this.loadDriversPickUpData(this.state.vendorPickUp.id)
        }

        if (this.state.vendorDropOff && !this.state.driversDropOffDataLoaded) {
            this.loadDriversDropOffData(this.state.vendorDropOff.id)
        }

        if (this.state.driverPickUp && !this.state.pickUpDriverContactLoaded) {
            this.loadPickUpDriverContact(this.state.driverPickUp.id)
        }

        if (this.state.orderData && this.state.orderDataLoaded && !this.state.orderUserDataLoaded) {
            this.loadOrderUserData()
        }

        const quoteETAs = {};


        if (this.state.orderData) {
            quoteETAs.air = this.grabData('air') ? this.grabData('air') : null;
            quoteETAs.scheduledAir = this.grabData('cargoAir') ? this.grabData('cargoAir') : null;
            quoteETAs.ground = this.grabData('ground') ? this.grabData('ground') : null;
            quoteETAs.ltl = this.grabData('autoLtl') ? this.grabData('autoLtl') : null;
            quoteETAs.additionalOptions = this.grabData('ltl') ? this.grabData('ltl') : null;

            for (let key in quoteETAs) {
                const quote = quoteETAs[key];
                if (quote && quote.quoteETA && quote.quoteETA.seconds) quoteETAs[key].quoteETA = quote.quoteETA.toDate();
            }
            console.log(quoteETAs);
        }

        return (
            <div>
                {this.state.messageSent ? (
                    <GridContainer justify="center">
                        <GridItem xs={11}>
                            <h4 className={classes.textPrimary}>Order Submitted!</h4>

                        </GridItem>
                    </GridContainer>
                ) : (
                    <GridContainer style={{ marginTop: "-30px" }} justify="center">
                        {/* {
                this.state.mapDataSaved ?
                  <GridItem xs={12} md={8}>
                    <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                  </GridItem>
                  : null
              } */}
                        <GridItem xs={12}>
                            <div className={classes.formContainer}>
                                <form onSubmit={this.handleSubmit}
                                >
                                    <GridContainer justify="center">
                                        <GridItem xs={11}>
                                            {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error: {this.state.messageError}</h5> : null}
                                            {this.state.step1 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 1 of 4</h3>
                                                    <p>Tell us who you are and where you're coming from.</p>
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="role"
                                                            className={classes.selectLabel}>
                                                            YOUR ROLE:
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.role}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'role',
                                                                name: 'role'
                                                            }}
                                                        >
                                                            {
                                                                role.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/*<FormControl
                          fullWidth
                          className={classes.selectFormControl}>
                          <InputLabel
                            htmlFor="shippingmode"
                            className={classes.selectLabel}>
                            SHIPPING MODE:
                  </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.shippingMode}
                            onChange={this.handleSelectChange}
                            inputProps={{
                              id: 'shippingMode',
                              name: 'shippingMode'
                            }}
                          >
                            {
                              shippingModes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                  value={item}
                                  key={item}
                                >{item}</MenuItem>
                              ))
                            }
                          </Select>
                          </FormControl>*/}

                                                    <br />
                                                    <br />
                                                    <h4 className={classes.bodyText}><b>Origin Details</b></h4>

                                                    <CustomInput
                                                        labelText="Business Name"
                                                        id="originBusinessName"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.originBusinessName ? this.state.originBusinessName : ''
                                                        }}
                                                    />

                                                    <CustomInput
                                                        labelText="Address"
                                                        id="originAddress"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.originAddress ? this.state.originAddress : ''
                                                        }}
                                                    />
                                                    <GridContainer justify="center">
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="City"
                                                                id="originCity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originCity ? this.state.originCity : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                                                            <CustomInput
                                                                labelText="State"
                                                                id="originState"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originState ? this.state.originState : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3}>
                                                            <CustomInput
                                                                labelText="ZIP"
                                                                id="originZip"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originZip ? this.state.originZip : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="originType"
                                                                    className={classes.selectLabel}>
                                                                    LOCATION TYPE:
                                                                </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.originType}
                                                                    onChange={this.handleSelectChange}
                                                                    defaultValue={this.state.originZip ? this.state.originZip : ''}
                                                                    inputProps={{
                                                                        id: 'originType',
                                                                        name: 'originType'
                                                                    }}
                                                                >
                                                                    {
                                                                        locationTypes.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer style={{ marginTop: "10px" }}>
                                                        <GridItem xs={6}>
                                                            <Datetime
                                                                selected={this.state.pickUpDate}
                                                                onChange={this.handlePickUpDateChange}
                                                                defaultValue={this.state.pickUpDate ? this.state.pickUpDate : ''}
                                                                timeFormat={true}
                                                                isValidDate={this.valid}
                                                                renderInput={(dateInputProps, open, close) => (
                                                                    <CustomInput
                                                                        inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                                                                        onBlur={close}
                                                                        onFocus={open}
                                                                        labelText="Pickup Date"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleTogglePickupServices('Lift Gate')}
                                                                            checked={this.state.pickUpServices.indexOf('Lift Gate') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Lift Gate at Pickup Point'
                                                                />
                                                            </div><br />
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleTogglePickupServices('Limited Access')}
                                                                            checked={this.state.pickUpServices.indexOf('Limited Access') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Limited Access Pick Up'
                                                                />
                                                            </div>

                                                        </GridItem>
                                                    </GridContainer>

                                                    <Button
                                                        style={{ float: "right", marginTop: "20px" }}
                                                        color="primary"
                                                        onClick={() => this.saveOrigin()}
                                                    >NEXT</Button>
                                                </div>
                                                : null}

                                            {/* 
                        <CustomInput
                          labelText="Notes"
                          id="description"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            id: "pickUpNotes",
                            name: "pickUpNotes",
                            type: "text",
                            multiline: true,
                            rows: 5,
                            onChange: (event) => this.handleChange(event)
                          }}
                        /> */}

                                            {this.state.step2 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 2 of 4</h3>
                                                    <p>Tell us where you're going.</p>

                                                    <h4 className={classes.bodyText}><b>Receiver Details</b></h4>

                                                    <CustomInput
                                                        labelText="Business Name"
                                                        id="destinationBusinessName"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.destinationBusinessName ? this.state.destinationBusinessName : ''
                                                        }}
                                                    />

                                                    <CustomInput
                                                        labelText="Address"
                                                        id="destinationAddress"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.destinationAddress ? this.state.destinationAddress : ''
                                                        }}
                                                    />
                                                    <GridContainer justify="center">
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="City"
                                                                id="destinationCity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationCity ? this.state.destinationCity : ''

                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                                                            <CustomInput
                                                                labelText="State"
                                                                id="destinationState"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationState ? this.state.destinationState : ''

                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3}>
                                                            <CustomInput
                                                                labelText="ZIP"
                                                                id="destinationZip"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationZip ? this.state.destinationZip : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="destinationType"
                                                            className={classes.selectLabel}>
                                                            LOCATION TYPE:
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.destinationType}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'destinationType',
                                                                name: 'destinationType'
                                                            }}
                                                        >
                                                            {
                                                                locationTypes.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    <GridContainer style={{ marginTop: "10px" }}>
                                                        <GridItem xs={6}>
                                                            <Datetime
                                                                selected={this.state.dropOffDate}
                                                                onChange={this.handleDropOffDateChange}
                                                                defaultValue={this.state.dropOffDate ? this.state.dropOffDate : ''}
                                                                timeFormat={true}
                                                                isValidDate={this.valid}
                                                                renderInput={(dateInputProps, open, close) => (
                                                                    <CustomInput
                                                                        inputProps={{ ...dateInputProps, id: 'dropOffDate', name: 'dropOffDate', required: true, }}
                                                                        onBlur={close}
                                                                        onFocus={open}
                                                                        labelText="Drop Off Date"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleDropOffServices('Lift Gate')}
                                                                            checked={this.state.dropOffServices.indexOf('Lift Gate') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Lift Gate at Pickup Point'
                                                                />
                                                            </div><br />
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleDropOffServices('Limited Access')}
                                                                            checked={this.state.dropOffServices.indexOf('Limited Access') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Limited Access Pick Up'
                                                                />
                                                            </div>

                                                        </GridItem>

                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ marginTop: "20px" }}
                                                                onClick={() => this.step2Back()}
                                                            >BACK</Button>
                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ float: "right", marginTop: "20px" }}
                                                                onClick={() => this.saveDestination()}
                                                            >NEXT</Button>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                : null}

                                            {/* <CustomInput
                              labelText="Notes"
                              id="dropOffNotes"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 5,
                                onChange: (event) => this.handleChange(event)
                              }}
                            /> */}
                                            {this.state.step3 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 3 of 4</h3>
                                                    <p>Tell us who we'll be dealing with and when.</p>
                                                    <p><b>Who can we contact at the origin address?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Name"
                                                                id="originContactName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactName ? this.state.originContactName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Email"
                                                                id="originContactEmail"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactEmail ? this.state.originContactEmail : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Phone"
                                                                id="originContactPhone"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactPhone ? this.state.originContactPhone : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <p><b>What are their business hours?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Open"
                                                                id="originOpenTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originOpenTime ? this.state.originOpenTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={2}>
                                                            <p>to</p>
                                                        </GridItem>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Close"
                                                                id="originCloseTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originCloseTime ? this.state.originCloseTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <p><b>When should we pick up the freight?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={2}>
                                                            <p>Between</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="Start"
                                                                id="originStartTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={1}>
                                                            <p>and</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="End"
                                                                id="originEndTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <br /> <br />
                                                    <p><b>Who can we contact at the destination address?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Name"
                                                                id="destinationContactName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactName ? this.state.destinationContactName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Email"
                                                                id="destinationContactEmail"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactEmail ? this.state.destinationContactEmail : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Phone"
                                                                id="destinationContactPhone"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactPhone ? this.state.destinationContactPhone : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <p><b>What are their business hours?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Open"
                                                                id="destinationOpenTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationOpenTime ? this.state.destinationOpenTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={2}>
                                                            <p>to</p>
                                                        </GridItem>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Close"
                                                                id="destinationCloseTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationCloseTime ? this.state.destinationCloseTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <p><b>When should we drop off the freight?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={2}>
                                                            <p>Between</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="Start"
                                                                id="destinationStartTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={1}>
                                                            <p>and</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="End"
                                                                id="destinationEndTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ marginTop: "20px" }}
                                                                onClick={() => this.step3Back()}
                                                            >BACK</Button>
                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ float: "right", marginTop: "20px" }}
                                                                onClick={() => this.saveFreight()}
                                                            >NEXT</Button>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                : null}
                                            {this.state.step4 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 4 of 4</h3>
                                                    <p>Tell us what you are shipping.</p>





                                                    <h3 className={classes.bodyText}>ITEM #1</h3>
                                                    <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    onClick={() => this.handleToggleServices('Hazmat')}
                                                                    checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                                    color="primary"
                                                                    classes={{
                                                                        checked: classes.checked,
                                                                        root: classes.checkRoot
                                                                    }}
                                                                />
                                                            }
                                                            classes={{ label: classes.bodyText }}
                                                            label='Hazmat'
                                                        />
                                                    </div>
                                                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    onClick={() => this.handleToggleServices('Over Length')}
                                                                    checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                                    color="primary"
                                                                    classes={{
                                                                        checked: classes.checked,
                                                                        root: classes.checkRoot
                                                                    }}
                                                                />
                                                            }
                                                            classes={{ label: classes.bodyText }}
                                                            label='Over Length'
                                                        />
                                                    </div>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="UN Number"
                                                                id="unNumber"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.unNumber ? this.state.unNumber : ''

                                                                }}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="Proper Shipping Name"
                                                                id="properShippingName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.properShippingName ? this.state.properShippingName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="packaging"
                                                            className={classes.selectLabel}>
                                                            PACKAGING:
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.packaging}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'packaging',
                                                                name: 'packaging'
                                                            }}
                                                        >
                                                            {
                                                                packagingTypes.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>


                                                    <CustomInput
                                                        labelText="Qty"
                                                        id="quantity"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "number",
                                                            min: "0",
                                                            step: "1",
                                                            onChange: (event) => this.handleChange(event)
                                                        }}
                                                    />
                                                    <CustomInput
                                                        labelText="Total Weight"
                                                        id="weight"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "number",
                                                            min: "0",
                                                            step: "1",
                                                            onChange: (event) => this.handleChange(event)
                                                        }}
                                                    />
                                                    {
                                                        this.state.packaging == "Pallets (enter dimensions)" ?
                                                            <GridContainer>
                                                                <GridItem xs={3}>
                                                                    <CustomInput
                                                                        labelText="Height"
                                                                        id="height"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.height ? this.state.height : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                                <GridItem xs={4}>
                                                                    <CustomInput
                                                                        labelText="Width"
                                                                        id="width"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.width ? this.state.width : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                                <GridItem xs={3}>
                                                                    <CustomInput
                                                                        labelText="Depth"
                                                                        id="depth"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.depth ? this.state.depth : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            : null
                                                    }

                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="class"
                                                            className={classes.selectLabel}>
                                                            FREIGHT CLASS:
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.class}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'class',
                                                                name: 'class'
                                                            }}
                                                        >
                                                            {
                                                                freightClass.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {!this.state.item2 ?
                                                        <Button
                                                            color="primary"
                                                            onClick={() => this.addItem()}
                                                        >
                                                            ADD ITEM
                                                        </Button>
                                                        : null}
                                                    {this.state.item2 ?
                                                        <div>
                                                            <h3 className={classes.bodyText}>ITEM #2</h3>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleServices('Hazmat')}
                                                                            checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Hazmat'
                                                                />
                                                            </div>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleServices('Over Length')}
                                                                            checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Over Length'
                                                                />
                                                            </div>
                                                            <GridContainer>
                                                                <GridItem xs={6}>
                                                                    <CustomInput
                                                                        labelText="UN Number"
                                                                        id="unNumber"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event)
                                                                        }}
                                                                    />

                                                                </GridItem>
                                                                <GridItem xs={6}>
                                                                    <CustomInput
                                                                        labelText="Proper Shipping Name"
                                                                        id="propperShippingName"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "text",
                                                                            onChange: (event) => this.handleChange(event)
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="packaging"
                                                                    className={classes.selectLabel}>
                                                                    PACKAGING:
                                                                </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.packaging}
                                                                    onChange={this.handleSelectChange}
                                                                    inputProps={{
                                                                        id: 'packaging',
                                                                        name: 'packaging'
                                                                    }}
                                                                >
                                                                    {
                                                                        packagingTypes.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>


                                                            <CustomInput
                                                                labelText="Qty"
                                                                id="quantity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "number",
                                                                    min: "0",
                                                                    step: "1",
                                                                    onChange: (event) => this.handleChange(event)
                                                                }}
                                                            />
                                                            <CustomInput
                                                                labelText="Total Weight"
                                                                id="weight"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "number",
                                                                    min: "0",
                                                                    step: "1",
                                                                    onChange: (event) => this.handleChange(event)
                                                                }}
                                                            />
                                                            {
                                                                this.state.packaging == "Pallets (enter dimensions)" ?
                                                                    <GridContainer>
                                                                        <GridItem xs={3}>
                                                                            <CustomInput
                                                                                labelText="Height"
                                                                                id="height"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                        <GridItem xs={4}>
                                                                            <CustomInput
                                                                                labelText="Width"
                                                                                id="width"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                        <GridItem xs={3}>
                                                                            <CustomInput
                                                                                labelText="Depth"
                                                                                id="depth"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                    </GridContainer>
                                                                    : null
                                                            }

                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="class"
                                                                    className={classes.selectLabel}>
                                                                    FREIGHT CLASS:
                                                                </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.class}
                                                                    onChange={this.handleSelectChange}
                                                                    inputProps={{
                                                                        id: 'class',
                                                                        name: 'class'
                                                                    }}
                                                                >
                                                                    {
                                                                        freightClass.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </div>
                                                        : null}


                                                    {this.state.flights && this.state.flights.map(flight => {
                                                        if (flight.Stops.length == 0) {
                                                            return (
                                                                <div>
                                                                    <Card style={{ backgroundColor: "white", boxShadow: "0px 0px 5px 0px #888888" }}>
                                                                        {/* <CardHeader>
                          <h5 style={{ color: "black" }}> <i>Case #{flight.id}</i> <br /></h5>
                        </CardHeader> */}
                                                                        <CardBody>
                                                                            <p><span style={{ color: "black" }}>Carrier:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Carriers}</span> </p>
                                                                            {/*<p><span style={{ color: "black" }}>Stops:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Stops.length}</span> </p>
                          <p>Flights: {flight.FlightNumbers.map(flight => {
                            return (
                              <p>
                                {flight.FlightNumber} <br />{flight.CarrierId}
                              </p>
                            )
                          })}</p>*/}
                                                                            <GridContainer>
                                                                                <GridItem xs={6}>
                                                                                    {String(flight.Departure)}
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                    {String(flight.Arrival)}
                                                                                </GridItem>
                                                                            </GridContainer>
                                                                        </CardBody>

                                                                    </Card>
                                                                </div>
                                                            )
                                                        } else {
                                                            null
                                                        }
                                                    })}
                                                    {this.state.assigningAction ? (
                                                        <div>
                                                            <p className={classes.bodyText}>{this.state.assigningAction}</p>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <GridContainer>
                                                                <GridItem xs={6}>
                                                                    <Button
                                                                        color="primary"
                                                                        style={{ marginTop: "20px" }}
                                                                        onClick={() => this.step4Back()}
                                                                    >BACK</Button>
                                                                </GridItem>
                                                                <GridItem xs={6}>
                                                                    <Button
                                                                        color="primary"
                                                                        style={{ float: "right", marginTop: "20px" }}
                                                                        onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                                                    >NEXT</Button>
                                                                </GridItem>
                                                            </GridContainer>

                                                        </div>

                                                    )}


                                                </div>

                                                : null}
                                            {this.state.step5 ?
                                                <GridContainer xs={12}>
                                                    <br />
                                                    <GridContainer>
                                                        <GridContainer style={{ marginBottom: "20px", padding: "auto", width: "100%" }}>
                                                            <GridItem xs={3} md={2} >
                                                                <h4 ><b>Summary Order # {this.state.orderData ? this.state.orderData.freightBillNumber : null}</b></h4>
                                                                <p><i>{this.state.orderData ? this.state.orderData.id : null}</i></p>
                                                            </GridItem>
                                                            <GridContainer xs={8}>
                                                                <GridItem xs={8} md={6} sm={3}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        className={classes.selectFormControl}>

                                                                        <InputLabel
                                                                            htmlFor="status"
                                                                            className={classes.selectLabel}>
                                                                            Shipment Operational Status:
                                                                        </InputLabel>
                                                                        <Select
                                                                            MenuProps={{
                                                                                className: classes.selectMenu
                                                                            }}
                                                                            classes={{
                                                                                select: classes.select
                                                                            }}
                                                                            value={this.state.orderData && this.state.orderData.status}
                                                                            onChange={(e) => {
                                                                                this.changeShipmentStatus(e);
                                                                            }}
                                                                            defaultValue={this.state.orderData && this.state.orderData.status}
                                                                            inputProps={{
                                                                                id: 'status',
                                                                                name: 'status'
                                                                            }}
                                                                        >
                                                                            {
                                                                                this.shipmentStatuses.map((item) => (
                                                                                    <MenuItem
                                                                                        classes={{
                                                                                            root: classes.selectMenuItem
                                                                                        }}
                                                                                        value={item}
                                                                                        key={item}
                                                                                    >{item}</MenuItem>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                    {this.state.orderData && this.state.orderData.status}
                                                                </GridItem>

                                                                <GridItem xs={4} md={6} sm={3}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        className={classes.selectFormControl}>

                                                                        <InputLabel
                                                                            htmlFor="financialStatus"
                                                                            className={classes.selectLabel}>
                                                                            Shipment Accounting Status:
                                                                        </InputLabel>
                                                                        <Select
                                                                            MenuProps={{
                                                                                className: classes.selectMenu
                                                                            }}
                                                                            classes={{
                                                                                select: classes.select
                                                                            }}
                                                                            value={this.state.orderData && this.state.orderData.financialStatus}
                                                                            onChange={(e) => {
                                                                                this.changeShipmentStatus(e);
                                                                            }}
                                                                            defaultValue={this.state.orderData && this.state.orderData.financialStatus}
                                                                            inputProps={{
                                                                                id: 'financialStatus',
                                                                                name: 'financialStatus'
                                                                            }}
                                                                        >
                                                                            {
                                                                                this.financialStatuses.map((item) => (
                                                                                    <MenuItem
                                                                                        classes={{
                                                                                            root: classes.selectMenuItem
                                                                                        }}
                                                                                        value={item}
                                                                                        key={item}
                                                                                    >{item}</MenuItem>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                    {this.state.orderData && this.state.orderData.financialStatus}

                                                                </GridItem>
                                                                <GridItem xs={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        className={classes.selectFormControl}>

                                                                        <InputLabel
                                                                            htmlFor="deliveryType"
                                                                            className={classes.selectLabel}>
                                                                            Delivery Type:
                                                                        </InputLabel>
                                                                        <Select
                                                                            MenuProps={{
                                                                                className: classes.selectMenu
                                                                            }}
                                                                            classes={{
                                                                                select: classes.select
                                                                            }}
                                                                            value={this.state.orderData && this.state.orderData.deliveryType}
                                                                            onChange={(e) => {
                                                                                this.saveShipmentStatus(e.target.name, e.target.value);
                                                                            }}
                                                                            defaultValue={this.state.orderData && this.state.orderData.deliveryType}
                                                                            inputProps={{
                                                                                id: 'deliveryType',
                                                                                name: 'deliveryType'
                                                                            }}
                                                                        >
                                                                            {
                                                                                this.deliveryTypes.map((item) => (
                                                                                    <MenuItem
                                                                                        classes={{
                                                                                            root: classes.selectMenuItem
                                                                                        }}
                                                                                        value={item.value}
                                                                                        key={item.string}
                                                                                    >{item.string}</MenuItem>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                    {/* {this.state.orderData && deliveryTypes.filter(item => item.value === this.state.orderData.deliveryType)[0].string} */}
                                                                    {this.state.orderData && this.state.orderData.deliveryType}
                                                                </GridItem>
                                                                <GridItem xs={6} md={6} sm={3}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        className={classes.selectFormControl}>

                                                                        <InputLabel
                                                                            htmlFor="billingParty"
                                                                            className={classes.selectLabel}>
                                                                            Billing Party
                                                                        </InputLabel>
                                                                        <Select
                                                                            MenuProps={{
                                                                                className: classes.selectMenu
                                                                            }}
                                                                            classes={{
                                                                                select: classes.select
                                                                            }}
                                                                            value={this.state.orderData && this.state.orderData.billingParty}
                                                                            onChange={(e) => {
                                                                                this.saveShipmentStatus(e.target.name, e.target.value);
                                                                            }}
                                                                            defaultValue={this.state.orderData && this.state.orderData.billingParty}
                                                                            inputProps={{
                                                                                id: 'billingParty',
                                                                                name: 'billingParty'
                                                                            }}
                                                                        >
                                                                            {
                                                                                this.billingParties.map((item) => (
                                                                                    <MenuItem
                                                                                        classes={{
                                                                                            root: classes.selectMenuItem
                                                                                        }}
                                                                                        value={item}
                                                                                        key={item}
                                                                                    >{item}</MenuItem>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                    {/* {this.state.orderData && deliveryTypes.filter(item => item.value === this.state.orderData.deliveryType)[0].string} */}
                                                                    {this.state.orderData && this.state.orderData.billingParty}
                                                                </GridItem>
                                                            </GridContainer>

                                                        </GridContainer>

                                                        <GridItem xs={12} md={3}>
                                                            <Button
                                                                color='danger'
                                                                style={{ marginTop: "20px" }}
                                                                onClick={() => this.cancelOrder()}
                                                            >CANCEL ORDER</Button>
                                                        </GridItem>
                                                        <GridItem xs={12} md={7}>
                                                            <GridContainer>
                                                                {console.log("Before prompt", this.state.promptModal, this.state.temp)}
                                                                <UserConfirmModal
                                                                    isOpen={this.state.promptModal}
                                                                    closeModal={() => this.closeModal('promptModal')}
                                                                    yesFunc={() => {
                                                                        this.saveShipmentStatus(this.state.temp.name, this.state.temp.value);
                                                                        this.closeModal('promptModal');
                                                                    }}
                                                                    noFunc={() => {
                                                                        this.closeModal('promptModal');
                                                                    }}
                                                                >
                                                                    {this.state.temp && (
                                                                        <React.Fragment>
                                                                            <GridItem xs={12}>
                                                                                <p>Are you sure you would like to roll the status back?</p>
                                                                            </GridItem>
                                                                            <GridItem>
                                                                                <p><b>Previous:</b> {this.state.orderData[this.state.temp.name]}</p>
                                                                            </GridItem>
                                                                            <GridItem>
                                                                                <p><b>New:</b> {this.state.temp.value}</p>
                                                                            </GridItem>
                                                                        </React.Fragment>
                                                                    )}

                                                                </UserConfirmModal>
                                                            </GridContainer>
                                                        </GridItem>
                                                    </GridContainer>

                                                    <GridContainer xs={12}>

                                                        <GridItem xs={12}>
                                                            <GridItem xs={12}>
                                                                <Typography variant="h4" style={{ textAlign: "center" }}>
                                                                    Summary
                                                                </Typography>
                                                            </GridItem>
                                                            {this.state.orderData &&
                                                                <PartyFreightSummary
                                                                    classes={classes}
                                                                    orderID={this.state.orderData.id}
                                                                    orderData={this.state.orderData}
                                                                    origin={this.state.orderData.origin}
                                                                    destination={this.state.orderData.destination}
                                                                    thirdParty={this.state.orderData.thirdParty}
                                                                    items={this.state.orderData.items}
                                                                    shipperName={this.state.orderData.shipperName}
                                                                    billingParty={this.state.orderData.billingParty}
                                                                    isEditable={true}
                                                                    // NEW PROPS FOR EDIT MODALS
                                                                    handleClickOpen={this.handleClickOpen}
                                                                    handleClose={this.handleClose}
                                                                    businessQuery={this.state.businessQuery}
                                                                    userQuery={this.state.userQuery}
                                                                    errorMessage={this.state.errorMessage}
                                                                    assignBusiness={this.assignBusiness}
                                                                    assignUser={this.assignUser}
                                                                    handleChange={this.handleChange}
                                                                    handleArrChange={this.handleArrChange}
                                                                    handleSelectChange={this.handleSelectChangeStateObj}
                                                                    handleDateChange={this.handleDateChange}
                                                                    handleToggleServices={this.handleToggleServices}
                                                                    saveInfo={this.saveInfo}
                                                                    addItem={this.addItem}
                                                                    removeItem={this.removeItem}
                                                                    handleItemChange={this.handleItemChange}
                                                                    handleItemSelectChange={this.handleItemSelectChange}
                                                                    handleToggleItemServices={this.handleToggleItemServices}
                                                                    handleSelectChangeObj={this.handleSelectChangeObj}
                                                                    onAssignPic={this.assignPic}
                                                                    removePicture={this.removePicture}
                                                                    saveFreight={this.saveFreight}
                                                                    updateOrigin={this.state.updateOrigin}
                                                                    updateDestination={this.state.updateDestination}
                                                                    updateThirdParty={this.state.updateThirdParty}
                                                                    updateFreight={this.state.updateFreight}
                                                                    // END
                                                                    chat={true}
                                                                    openChats={this.state.openChats}
                                                                    openChat={this.openChat}
                                                                />
                                                            }

                                                            <br />
                                                        </GridItem>
                                                        <GridItem xs={12} md={6}>
                                                            <b>Quote Delivery Types:</b>
                                                            {this.state.orderData && (
                                                                <Grid container className={classes.quotesContainer} alignItems='center' spacing={1}>
                                                                    <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            md={5}
                                                                        >
                                                                            <TextField
                                                                                label="NEXT FLIGHT OUT :"
                                                                                id="airQuote"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                type="text"
                                                                                onChange={(event) => this.handleChange(event)}
                                                                                defaultValue={this.grabData('airQuote') ? this.grabData('airQuote') : ''}
                                                                            />
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            className={classes.dateTimePicker}
                                                                        >
                                                                            <p>ETA:</p>
                                                                            <DatePicker
                                                                                onChange={e => this.handleQuoteDateTimeChange(e, 'air')}
                                                                                value={quoteETAs.air ? quoteETAs.air.quoteETA : null}
                                                                            />
                                                                        </Grid>
                                                                        <Grid container item xs>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="startTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    START WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.air ? quoteETAs.air.start : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'air', 'start')}
                                                                                    inputProps={{
                                                                                        id: 'startTimeWindow',
                                                                                        name: 'startTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="endTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    END WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.air ? quoteETAs.air.end : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'air', 'end')}
                                                                                    inputProps={{
                                                                                        id: 'endTimeWindow',
                                                                                        name: 'endTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12}><Divider /></Grid>
                                                                    <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                                                        <Grid item xs={12} md={5}>
                                                                            <Grid container alignItems='center'>
                                                                                <Grid
                                                                                    item
                                                                                    xs
                                                                                    className={classes.nextDayAutoComplete}
                                                                                >
                                                                                    <Autocomplete
                                                                                        style={{
                                                                                            height: 80,
                                                                                        }}
                                                                                        value={this.grabData('subDeliveryType')}
                                                                                        onChange={(event, newValue) => this.setState({ subDeliveryType: newValue })}
                                                                                        filterOption={filter}
                                                                                        selectOnFocus
                                                                                        handleHomeEndKeys
                                                                                        id="sub-delivery-type"
                                                                                        options={['Next Day Air', 'Air Truck']}
                                                                                        getOptionLabel={(option) => option}
                                                                                        renderOption={(option) => option}
                                                                                        freeSolo
                                                                                        fullWidth
                                                                                        renderInput={(params) => (
                                                                                            <TextField
                                                                                                {...params}
                                                                                                label="NEXT DAY AIR"
                                                                                                variant="outlined"
                                                                                                onChange={(e) =>
                                                                                                    e.target.value &&
                                                                                                    this.setState({
                                                                                                        subDeliveryType: e.target.value,
                                                                                                    })
                                                                                                }
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs
                                                                                    className={classes.nextDayTextField}
                                                                                >
                                                                                    <TextField
                                                                                        style={{
                                                                                            height: 80,
                                                                                        }}
                                                                                        variant="outlined"
                                                                                        label="NEXT DAY AIR $:"
                                                                                        id="cargoAirQuote"
                                                                                        type="text"
                                                                                        fullWidth
                                                                                        onChange={(event) =>
                                                                                            this.handleChange(event)
                                                                                        }
                                                                                        defaultValue={
                                                                                            this.grabData('cargoAirQuote')
                                                                                                ? this.grabData('cargoAirQuote')
                                                                                                : ''
                                                                                        }
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            className={classes.dateTimePicker}
                                                                        >
                                                                            <p>ETA:</p>
                                                                            <DatePicker
                                                                                onChange={e => this.handleQuoteDateTimeChange(e, 'cargoAir')}
                                                                                value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.quoteETA : null}
                                                                            />
                                                                        </Grid>
                                                                        <Grid container item xs>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="startTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    START WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.start : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'cargoAir', 'start')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'startTimeWindow',
                                                                                        name: 'startTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="endTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    END WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.end : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'cargoAir', 'end')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'endTimeWindow',
                                                                                        name: 'endTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12}><Divider /></Grid>
                                                                    <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            md={5}
                                                                        >
                                                                            <TextField
                                                                                label="DEDICATED GROUND:"
                                                                                variant="outlined"
                                                                                id="groundQuote"
                                                                                fullWidth
                                                                                type="text"
                                                                                onChange={(event) =>
                                                                                    this.handleChange(event)
                                                                                }
                                                                                defaultValue={
                                                                                    this.grabData('groundQuote')
                                                                                        ? this.grabData('groundQuote')
                                                                                        : ''
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            className={classes.dateTimePicker}
                                                                        >
                                                                            <p>ETA:</p>
                                                                            <DatePicker
                                                                                onChange={e => this.handleQuoteDateTimeChange(e, 'ground')}
                                                                                value={quoteETAs.ground ? quoteETAs.ground.quoteETA : null}
                                                                            />
                                                                        </Grid>
                                                                        <Grid container item xs>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="startTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    START WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.ground ? quoteETAs.ground.start : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'ground', 'start')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'startTimeWindow',
                                                                                        name: 'startTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="endTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    END WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.ground ? quoteETAs.ground.end : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'ground', 'end')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'endTimeWindow',
                                                                                        name: 'endTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12}><Divider /></Grid>
                                                                    <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            md={5}
                                                                        >
                                                                            <TextField
                                                                                label="LTL:"
                                                                                id="autoLtlQuote"
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                type="text"
                                                                                onChange={(event) =>
                                                                                    this.handleChange(event)
                                                                                }
                                                                                defaultValue={
                                                                                    this.grabData('autoLtlQuote')
                                                                                        ? this.grabData('autoLtlQuote')
                                                                                        : ''
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            className={classes.dateTimePicker}
                                                                        >
                                                                            <p>ETA:</p>
                                                                            <DatePicker
                                                                                onChange={e => this.handleQuoteDateTimeChange(e, 'autoLtl')}
                                                                                value={quoteETAs.ltl ? quoteETAs.ltl.quoteETA : null}
                                                                            />
                                                                        </Grid>
                                                                        <Grid container item xs>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="startTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    START WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.ltl ? quoteETAs.ltl.start : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'autoLtl', 'start')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'startTimeWindow',
                                                                                        name: 'startTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="endTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    END WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.ltl ? quoteETAs.ltl.end : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'autoLtl', 'end')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'endTimeWindow',
                                                                                        name: 'endTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12}><Divider /></Grid>
                                                                    <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            md={5}
                                                                        >
                                                                            <TextField
                                                                                label="DIRECT LTL:"
                                                                                variant="outlined"
                                                                                id="ltlQuote"
                                                                                fullWidth
                                                                                type="text"
                                                                                onChange={(event) =>
                                                                                    this.handleChange(event)
                                                                                }
                                                                                defaultValue={
                                                                                    this.grabData('ltlQuote')
                                                                                        ? this.grabData('ltlQuote')
                                                                                        : ''
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            className={classes.dateTimePicker}
                                                                        >
                                                                            <p>ETA:</p>
                                                                            <DatePicker
                                                                                onChange={e => this.handleQuoteDateTimeChange(e, 'ltl')}
                                                                                value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.quoteETA : null}
                                                                            />
                                                                        </Grid>
                                                                        <Grid container item xs>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="startTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    START WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.start : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'ltl', 'start')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'startTimeWindow',
                                                                                        name: 'startTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                            <FormControl
                                                                                fullWidth
                                                                                className={classes.selectFormControl}>
                                                                                <InputLabel
                                                                                    htmlFor="endTimeWindow"
                                                                                    className={classes.selectLabel}>
                                                                                    END WINDOW
                                                                                </InputLabel>
                                                                                <Select
                                                                                    MenuProps={{
                                                                                        className: classes.selectMenu
                                                                                    }}
                                                                                    classes={{
                                                                                        select: classes.select
                                                                                    }}
                                                                                    value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.end : ''}
                                                                                    onChange={e => this.handleQuoteWindowTimeChange(e, 'ltl', 'end')}
                                                                                    // defaultValue={''}
                                                                                    inputProps={{
                                                                                        id: 'endTimeWindow',
                                                                                        name: 'endTimeWindow'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        this.militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                                classes={{
                                                                                                    root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                            >{item}</MenuItem>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        style={{ paddingLeft: 10 }}
                                                                    >
                                                                        <MaterialButton
                                                                            style={{
                                                                                backgroundColor: '#00acc1',
                                                                                color: '#FFF',
                                                                            }}
                                                                            onClick={this.handleSubmit}
                                                                        >
                                                                            UPDATE QUOTE
                                                                        </MaterialButton>
                                                                    </Grid>
                                                                </Grid>
                                                            )}

                                                            {this.state.orderData && (
                                                                <GridContainer>
                                                                    {(this.state.orderData.airQuote) &&
                                                                        <GridItem xs={12} md={6}
                                                                            onClick={() => this.deliveryType("Air")}
                                                                        >
                                                                            <div style={{ margin: "5px", padding: "15px", borderRadius: "10px", boxShadow: "0px 2px 5px #ccc ", cursor: "pointer", backgroundColor: (this.state.deliveryType == "Air") ? "#efe6e6" : "#eee" }}
                                                                            >
                                                                                <h4><b>NEXT FLIGHT OUT:<br /> <span style={{ color: "red" }}>${this.state.orderData.airQuote}</span></b></h4>
                                                                                ETA: {quoteETAs.air ? `${moment(quoteETAs.air.quoteETA).format('MM/DD/YYYY')} ${[quoteETAs.air.start, quoteETAs.air.end].filter(Boolean).join(' - ')}` : ''}
                                                                            </div>
                                                                        </GridItem>
                                                                    }

                                                                    {(this.state.orderData.cargoAirQuote) &&
                                                                        <GridItem xs={12} md={6}
                                                                            onClick={() => this.deliveryType("Scheduled Air")}
                                                                        >
                                                                            <div style={{ margin: "5px", padding: "15px", borderRadius: "10px", boxShadow: "0px 2px 5px #ccc ", cursor: "pointer", backgroundColor: (this.state.deliveryType == "Scheduled Air") ? "#efe6e6" : "#eee" }}
                                                                            >

                                                                                <h4><b>{this.state.orderData.subDeliveryType ? this.state.orderData.subDeliveryType.toUpperCase() : 'NEXT DAY AIR'}:<br /> <span style={{ color: "red" }}>${this.state.orderData.cargoAirQuote}</span></b></h4>
                                                                                ETA: {quoteETAs.scheduledAir ? `${moment(quoteETAs.scheduledAir.quoteETA).format('MM/DD/YYYY')} ${[quoteETAs.scheduledAir.start, quoteETAs.scheduledAir.end].filter(Boolean).join(' - ')}` : ''}

                                                                            </div>
                                                                        </GridItem>
                                                                    }

                                                                    {(this.state.orderData.groundQuote) &&
                                                                        < GridItem xs={12} md={6}
                                                                            onClick={() => this.deliveryType("Ground")}
                                                                        >
                                                                            <div style={{ margin: "5px", padding: "15px", borderRadius: "10px", boxShadow: "0px 2px 5px #ccc ", cursor: "pointer", backgroundColor: (this.state.deliveryType == "Ground") ? "#efe6e6" : "#eee" }}
                                                                            >

                                                                                <h4><b>DEDICATED GROUND: <br /><span style={{ color: "red" }}>${this.state.orderData.groundQuote}</span></b></h4>
                                                                                ETA: {quoteETAs.ground ? `${moment(quoteETAs.ground.quoteETA).format('MM/DD/YYYY')} ${[quoteETAs.ground.start, quoteETAs.ground.end].filter(Boolean).join(' - ')}` : ''}
                                                                            </div>
                                                                        </GridItem>
                                                                    }


                                                                    {(this.state.orderData.autoLtlQuote) &&
                                                                        <GridItem xs={12} md={6}
                                                                            onClick={() => this.deliveryType("LTL")}
                                                                        >
                                                                            <div style={{ margin: "5px", padding: "15px", borderRadius: "10px", boxShadow: "0px 2px 5px #ccc ", cursor: "pointer", backgroundColor: (this.state.deliveryType == "LTL") ? "#efe6e6" : "#eee" }}
                                                                            >

                                                                                <h4><b>LTL:<br /><span style={{ color: "red" }}>${this.state.orderData.autoLtlQuote}</span></b> </h4>
                                                                                ETA: {quoteETAs.ltl ? `${moment(quoteETAs.ltl.quoteETA).format('MM/DD/YYYY')} ${[quoteETAs.ltl.start, quoteETAs.ltl.end].filter(Boolean).join(' - ')}` : ''}
                                                                            </div>

                                                                        </GridItem>
                                                                    }

                                                                    {(this.state.orderData.ltlQuote) &&
                                                                        <GridItem xs={12} md={6}
                                                                            onClick={() => this.deliveryType("Additional Options")}
                                                                        >
                                                                            <div style={{ margin: "5px", padding: "15px", borderRadius: "10px", boxShadow: "0px 2px 5px #ccc ", cursor: "pointer", backgroundColor: (this.state.deliveryType == "Additional Options") ? "#efe6e6" : "#eee" }}>

                                                                                <h4><b>DIRECT LTL:<br /><span style={{ color: "red" }}>${this.state.orderData.ltlQuote}</span></b> </h4>
                                                                                ETA: {quoteETAs.additionalOptions ? `${moment(quoteETAs.additionalOptions.quoteETA).format('MM/DD/YYYY')} ${[quoteETAs.additionalOptions.start, quoteETAs.additionalOptions.end].filter(Boolean).join(' - ')}` : ''}
                                                                            </div>

                                                                        </GridItem>
                                                                    }


                                                                    {this.state.orderData && (this.state.orderData.status == "quoted" || this.state.orderData.status === 'Quoted') &&
                                                                        <GridItem xs={12}>
                                                                            {this.state.deliveryType &&
                                                                                <div>
                                                                                    <p>{this.state.originErrorMessage && `The following details must be submitted for the origin: ${this.state.originErrorMessage}`}</p>
                                                                                    <p>{this.state.destinationErrorMessage && `The following details must be submitted for the destination: ${this.state.destinationErrorMessage}`}</p>
                                                                                    <Button
                                                                                        color="info"
                                                                                        style={{
                                                                                            marginTop: "20px"
                                                                                        }}
                                                                                        onClick={this.approveQuote}
                                                                                    >
                                                                                        APPROVE
                                                                                    </Button>
                                                                                </div>
                                                                            }
                                                                        </GridItem>}
                                                                    <GridItem xs={12}>
                                                                        <br />
                                                                        <Button

                                                                            style={{ color: "white", marginTop: "5px", backgroundColor: "#ff0000" }}
                                                                            onClick={this.declineQuote}
                                                                        >
                                                                            DECLINE ALL QUOTES
                                                                        </Button>
                                                                    </GridItem>
                                                                </GridContainer>
                                                            )}


                                                            {this.state.orderData &&
                                                                <FlightSearchForm onSelectFlight={this.selectFlight} onSelectAdditionalLegs={this.selectAdditionalLegs} flight1={this.state.flight ? this.state.flight : (this.state.orderData.flight ? this.state.orderData.flight : null)} extraFlights={this.state.additionalLegs ? this.state.additionalLegs : (this.state.orderData.additionalLegs ? this.state.orderData.additionalLegs : null)} originCity={this.state.orderData && this.state.orderData.origin.city} originState={this.state.orderData && this.state.orderData.origin.state} destinationCity={this.state.orderData && this.state.orderData.destination.city} destinationState={this.state.orderData && this.state.orderData.destination.state} />
                                                            }
                                                        </GridItem>

                                                    </GridContainer>

                                                    <br /><br />
                                                    {(pathname == "/completed-orders") ?
                                                        <div>
                                                            <h3 style={{}}><b>Delivery Information</b></h3>
                                                            CONDITION: <b>{this.state.orderData && this.state.orderData.CONDITION}</b>
                                                            <br />
                                                            POD: {this.state.orderData &&
                                                                this.state.orderData.BOLPICS.map((item) => (
                                                                    <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                                                ))
                                                            }
                                                            <br />
                                                            {
                                                                this.state.orderData &&
                                                                <div>
                                                                    DAMAGE: {this.state.orderData.DAMAGEPIC &&
                                                                        this.state.orderData.DAMAGEPICS.map((item) => (
                                                                            <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                                                        ))
                                                                    }
                                                                </div>
                                                            }

                                                        </div>
                                                        :
                                                        null}

                                                </GridContainer>
                                                : null}
                                            <br />
                                        </GridItem>
                                    </GridContainer>

                                </form>
                            </div>
                        </GridItem>
                    </GridContainer>

                )}
                <Snackbar open={this.state.errorSnack} autoHideDuration={6000} onClose={() => this.closeSnack('errorSnack')}>
                    <Alert onClose={() => this.closeSnack('errorSnack')} severity="error">
                        {this.state.errorSnackMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/QuoteOrderForm.jsx